import HTTP from '../lib/http'
class Api extends HTTP {
  constructor () {
    super()
  }
}

const http = new Api()
export default http